import { VPathKey } from '@/lib/history';
import { ILocation } from './bridge';
import { ClientCommand, ServerToClientCommand } from './socket';

export interface Dictionary<T> {
  [key: string]: T;
}

export interface MyLocation {
  name?: string;
  params?: Dictionary<string>;
  query?: Dictionary<string>;
  path?: string;
}

export enum VStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum VMessageType {
  HTTP = 'HTTP',
  WEBSOCKET = 'WEBSOCKET',
  OPENTOK = 'OPENTOK',
}

export interface IStatusMessage {
  status?: VStatus;
  type: VMessageType;
  errorCode?: string | number;
  errorMessage?: string;
}

export interface IEvent {
  action: VAction | ClientCommand | ServerToClientCommand;
  status?: IStatusMessage;
  startTime?: number;
  endTime?: number;
  extra?: { [x: string]: any } | null;
  target?: IPage;
  location?: IPage;
}

export enum OSType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export interface IDeviceInfo {
  deviceId?: string;
  userId?: string;
  appVersion?: string;
  osType?: OSType;
}

export interface IEventPackage {
  device: IDeviceInfo;
  transactionId: string;
  events: Array<IEvent>;
}

export interface IPage {
  pageName?: VPathKey;
  params?: object;
}

export enum VendorObjectType {
  SESSION = 'SESSION',
  PUBLISHER = 'PUBLISHER',
  SUBSCRIBER = 'SUBSCRIBER',
  OTHERS = 'OTHERS',
}

export enum VAction {
  PAGE_EVENT = 'PAGE_EVENT',

  CANCEL_CLICK = 'CANCEL_CLICK',
  CANCEL = 'CANCEL',

  SESSION = 'SESSION',
  PRECALL_SAVE_LOG = 'PRECALL_SAVE_LOG',
  PRECALL_CREDENTIAL = 'PRECALL_CREDENTIAL',
  RETRY_CLICK = 'RETRY_CLICK',
  CYCLE_CAMERA_CLICK = 'CYCLE_CAMERA_CLICK',
  SUBSCRIBER_MUTE_CLICK = 'SUBSCRIBER_MUTE_CLICK',
  PUBLISHER_MUTE_CLICK = 'PUBLISHER_MUTE_CLICK',

  AGENT_ISSUE_MODAL_CLICK = 'AGENT_ISSUE_MODAL_CLICK',

  NETWORK_ISSUE_TIP_SHOW = 'NETWORK_ISSUE_TIP_SHOW',

  // opentok
  OPENTOK_CONNECTED = 'OPENTOK_CONNECTED',
  OPENTOK_PUBLISHED = 'OPENTOK_PUBLISHED',
  OPENTOK_SUBSCRIBED = 'OPENTOK_SUBSCRIBED',
  OPENTOK_FAILED = 'OPENTOK_FAILED',
}
